import { createApi } from "@reduxjs/toolkit/query/react";

import { API_VALIDATOR_KEYS } from "@/constants/customer-portal/general.constant";
import { REQUEST_METHODS } from "@/constants/global-constants";
import { ICustomerUser } from "@/interfaces/customer-user.interface";
import { T_UpdateUserSchema } from "@/schemas/customer-portal/user-management-schema";
import { BaseWithAuth, getCustomerId } from "@/utils/helpers";

// Auth APIS
export const UserManagementApi = createApi({
  reducerPath: "UserManagementApi",
  baseQuery: BaseWithAuth(),
  tagTypes: [API_VALIDATOR_KEYS.USER],
  endpoints: (builder) => ({
    getCustomerUser: builder.query<
      GeneralResponse<ICustomerUser[]>,
      { filter: string }
    >({
      query: ({ filter }) => `customer/${getCustomerId()}/user${filter}`,
      providesTags: [API_VALIDATOR_KEYS.USER],
    }),
    mutateUser: builder.mutation<
      object,
      {
        method: REQUEST_METHODS;
        data: T_UpdateUserSchema | object;
        userId?: string;
      }
    >({
      query: ({ data, method, userId }) => ({
        url: `customer/${getCustomerId()}/user/${userId ?? ""}`,
        method: method.toUpperCase(),
        body: data,
      }),
      invalidatesTags: [API_VALIDATOR_KEYS.USER],
    }),
    updatePermission: builder.mutation<
      object,
      {
        data: T_UpdateUserSchema | object;
        userId: string;
      }
    >({
      query: ({ data, userId }) => ({
        url: `customer/${getCustomerId()}/user/permission/${userId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [API_VALIDATOR_KEYS.USER],
    }),
  }),
});

export const {
  useGetCustomerUserQuery,
  useMutateUserMutation,
  useUpdatePermissionMutation,
} = UserManagementApi;
